<app-header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="offers-header">
  <div class="page-content-wider">
    <h1 class="offers-header-title">{{getHeaderTitle()}}</h1>
    {{getHeaderText()}}
  </div>
</div>

<div class="page-content-wider">

  <div class="store-media-selectors-container">
    <div class="personal-lists-toolbar">
      <div class="list-type-selector-container personal-lists-type-selector">
        <div class="list-selection-text">{{getString('listSelection')}}</div>
        <nav class="list-type-selector" aria-label="Lists">
          <div class="list-type-wrapper" *ngFor="let listType of getListTypes(); let i = index">
            <a class="list-type-item" [routerLink]="getListTypeUrl(listType)" [class.active]="isActiveListType(listType)">
              <span class="material-icons list-type-icon" aria-hidden="true">{{listType.icon}}</span>
              <span class="list-type-label"><span *ngFor="let labelPart of getListTypeLabelParts(listType)">{{labelPart}}</span></span>
            </a>
            <div class="headerDivider" *ngIf="i != getListTypes().length - 1"></div>
          </div>
        </nav>
      </div>
      <div class="store-media-selectors-content">
        <app-store-selector class="store-selector-container" [useBrandIcons]="true" (onStoreChanged)="storeChanged()"></app-store-selector>
        <app-media-selector class="media-selector-container" [selectedMediaType]="selectedMediaType" [mediaTypes]="mediaTypesForDisplay"
        [nolinks]="true" (onMediaChanged)="mediaChanged($event)">
        </app-media-selector>

        <div class="actions-selector-container">
          <div class="actions-selection-text">{{getString('actions')}}</div>
          <div class="actions-icons-container">
            <div class="action-icon-wrapper" (click)="importiTunesLibrary()" *ngIf="showItunesImport()">
              <span class="material-icons action-icon">tilt_arrow_down</span>
              <div class="action-name">{{getString('import')}}</div>
            </div>
            <div class="action-icon-wrapper" (click)="importVuduLibrary()" *ngIf="showVuduImport()">
              <span class="material-icons action-icon">tilt_arrow_down</span>
              <div class="action-name">{{getString('import')}}</div>
            </div>
            <div class="action-icon-wrapper dropdown" [class.active]="isDropdownOpen(exportDDContent)" (click)="exportDropdownClicked()">
              <span class="material-icons action-icon export-icon">tilt_arrow_down</span>
              <div class="action-name">{{getString('export')}}</div>
              <div #exportDDContent class="dropdown-content dd-right">
                <span class="menu-item" (click)="exportWithUrl()">{{getString("exportWithURL")}}</span>
                <span class="menu-item" (click)="exportToCsv()">{{getString("exportAsCSV")}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="filters-container-test">

    <div class="small-horizontal-border"></div>

    <div class="normal-filters">
      <div class="filters-panel" [class.fp-close]="isFiltersPanelOpen == false">
        <div class="filter-test">
          <app-multichoice-menu class="dd-test" [title]="getString('genres')" [label]="getString('genres')" [itemList]="genres" [selectedItemsList]="selectedGenres" (selectionChanged)="genreChanged($event)"></app-multichoice-menu>
        </div>
        <div class="filter-test-mobile-sort">
          <app-dropdown class="dd-test" [label]="getString('sortBy')" [items]="sortValues" [selectedItem]="sortKey" [default]="sortValues[0]" [right]="true" (onItemSelected)="sortChanged('onsale', $event)"></app-dropdown>
        </div>
        <div class="filter-test" *ngIf="selectedMediaType == 'movies'">
          <app-dropdown class="dd-test" [label]="getString('quality')" [items]="qualityOptions" [selectedItem]="selectedQuality" [default]="qualityOptions[0]" [stringAttr]="'title'" [right]="true" (onItemSelected)="qualityChanged($event)"></app-dropdown>
        </div>
      </div>
    </div>

    <div class="special-filter">
      <app-dropdown class="sort float-right dd" [selectedItemWidth]="'180px'" [title]="getString('sortBy')" [items]="sortValues" [selectedItem]="sortKey" [right]="true" (onItemSelected)="sortChanged('onsale', $event)"></app-dropdown>
    </div>
  </div>

  <app-search-bar [query]="searchTerm" [showMedias]="false" [itemTypes]="mediaTypes" [activateSuggestions]="false"
    [selectedItemType]="selectedMediaType" [placeholder]="getString('findByTitle')" (onSearchClicked)="searchClicked($event)">
  </app-search-bar>

  <div *ngIf="searchTerm && searchTerm != ''" class="txt-algn-cntr">{{getString('search')}}: '{{searchTerm}}'
    <span (click)="cancelSearch()" class="cancel-search">X</span>
  </div>

  <div class="txt-algn-cntr purchases-title-container" [class.invisible]="!items"><h3>{{getString('myPurchases')}} - {{getString(getStore())}} {{getMedia()}} ({{totalItemCount}})</h3></div>

  <div class="items-container">

    <div class="item-container" *ngFor="let item of items; let i = index;">
      <app-date-separator [mode]="'day'" [shouldDisplay]="showDateSeparator(item, i)"
      [date]="getDate(item)"></app-date-separator>
      <app-grid-item-ownlist [item]="item" [priceHint]="'offerslist'" [store]="getStore()"
      (onRemoveFromOwnlistClicked)="removeFromOwnlistClicked(item)"
      (onRemoveFromWishlistClicked)="removeFromWishlist(item)"
      ></app-grid-item-ownlist>
    </div>

  </div>

  <div class="not-supported" *ngIf="!mediaSupportedForCountry()">{{getString('mediaNotSuportedForCountry')}}</div>

  <div class="results-end" *ngIf="resultsEndReached">{{getString('endOfResults')}}</div>
  <div class="results-end" *ngIf="techError">{{getString('technicalProblems')}}
    <div><button type="button" (click)="reload()">{{getString('reload')}}</button></div>
  </div>

</div>

<div *ngIf="showSpinner" class="spinner-container txt-algn-cntr">
  <app-spinner></app-spinner>
</div>

<app-scroll-top *ngIf="showScrollToTopButton"></app-scroll-top>

<app-modal #confirmRemoveFromOwnListModal [title]="getString('confirmation')" [confirmationModal]="true"
(onResult)="onConfirmRemoveFromOwnlistModalResult($event)">

  <div>{{getString('ownlistRemoveItemConfirm')}}</div>

</app-modal>

<app-authentication #authentication></app-authentication>

<app-modal #importiTunesLibraryModal [title]="getString('importiTunesLibrary')">
  <app-import-itunes-lib *ngIf="importiTunesLibraryModal.isOpen == true" (onClose)="reload();importiTunesLibraryModal.close()">
  </app-import-itunes-lib>
</app-modal>

<app-modal #importVuduLibraryModal [title]="getString('importVuduLibrary')">
  <app-import-vudu-lib *ngIf="importVuduLibraryModal.isOpen == true" (onClose)="reload();importVuduLibraryModal.close()">
  </app-import-vudu-lib>
</app-modal>

<app-modal #importWarning [okModal]="true">
  <span *ngIf="storeIsItunes()">{{getString('importiTunesStoreWarning')}}</span>
  <span *ngIf="storeIsVudu()">{{getString('importVuduStoreWarning')}}</span>
</app-modal>
